export interface HeroSlide {
  id: string;
  title: string;
  desc: string;
  tag: string;
  image: string;
  link: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "h1",
    title: "《星海回声》第二季官宣定档",
    desc: "全员回归，驶向更深处的星域，首支预告同步解禁。",
    tag: "新番焦点",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20young%20space%20crew%20on%20a%20futuristic%20ship%20deck%20gazing%20at%20a%20vast%20glowing%20nebula%2C%20flat%20cel%20shading%2C%20vivid%20green%20teal%20and%20deep%20space%20palette%2C%20dramatic%20clean%20wide%20background%2C%20official%20banner%20style&width=1600&height=800&seq=hero-01&orientation=landscape",
    link: "/news/detail/n1",
  },
  {
    id: "h2",
    title: "《雾都侦探社》本季口碑黑马",
    desc: "扎实的推理与克制的演出，冷静之中暗藏紧张感。",
    tag: "深度推荐",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20detective%20silhouette%20walking%20through%20a%20foggy%20city%20street%20under%20warm%20gaslamps%2C%20flat%20cel%20shading%2C%20deep%20teal%20and%20amber%20palette%2C%20dramatic%20clean%20wide%20background%2C%20mystery%20banner%20style&width=1600&height=800&seq=hero-02&orientation=landscape",
    link: "/works/detail/w3",
  },
  {
    id: "h3",
    title: "秋季新番大盘点",
    desc: "热血、日常、悬疑、治愈，帮你在海量新番中快速锁定目标。",
    tag: "新番指南",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20colorful%20lineup%20of%20hero%20silhouettes%20from%20different%20genres%20against%20a%20bright%20gradient%20sky%2C%20flat%20cel%20shading%2C%20energetic%20green%20orange%20and%20teal%20palette%2C%20clean%20wide%20background%2C%20season%20banner%20style&width=1600&height=800&seq=hero-03&orientation=landscape",
    link: "/news/detail/n2",
  },
  {
    id: "h4",
    title: "漫蛙线下嘉年华本周开启",
    desc: "三天免费开放，原画展、创作者见面会与限定周边等你来玩。",
    tag: "活动预告",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20festive%20exhibition%20hall%20with%20colorful%20banners%20and%20bright%20stage%20lights%2C%20flat%20cel%20shading%2C%20lively%20green%20and%20orange%20palette%2C%20clean%20wide%20background%2C%20event%20banner%20style&width=1600&height=800&seq=hero-04&orientation=landscape",
    link: "/news/detail/n4",
  },
];